import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["residential-roofing"];

export const Route = createFileRoute("/services/residential-roofing")({
  head: () => ({
    meta: [
      { title: "Residential Roofing Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Residential roofing across Southern California – repairs, replacements and full service for single-family homes and townhouses." },
      { property: "og:title", content: "Residential Roofing – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/residential-roofing" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});